import type { SVGProps } from "react";
import * as React from "react";

const SvgBook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 19.5H3zM6.5 17v-1zM20 18a1 1 0 1 0 0-2zM6.5 2V1zM20 2h1a1 1 0 0 0-1-1zm0 20v1a1 1 0 0 0 1-1zM4 4.5H3zm1 15c0-.398.158-.78.44-1.06l-1.415-1.415A3.5 3.5 0 0 0 3 19.5zm.44-1.06A1.5 1.5 0 0 1 6.5 18v-2a3.5 3.5 0 0 0-2.475 1.025zM6.5 18H20v-2H6.5zm0-15H20V1H6.5zM19 2v20h2V2zm1 19H6.5v2H20zM6.5 21a1.5 1.5 0 0 1-1.06-.44l-1.415 1.415A3.5 3.5 0 0 0 6.5 23zm-1.06-.44A1.5 1.5 0 0 1 5 19.5H3a3.5 3.5 0 0 0 1.025 2.475zM5 19.5v-15H3v15zm0-15c0-.398.158-.78.44-1.06L4.024 2.024A3.5 3.5 0 0 0 3 4.5zm.44-1.06A1.5 1.5 0 0 1 6.5 3V1a3.5 3.5 0 0 0-2.475 1.025z"
    />
  </svg>
);
export default SvgBook;
